import script from "./CreateProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProduct.vue?vue&type=script&setup=true&lang=js"

import "./CreateProduct.vue?vue&type=style&index=0&id=6b67c18e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b67c18e"]])

export default __exports__